import * as React from "react";
import { Link } from "gatsby";
import Layout from "../components/layout";

export default function CvPau() {
  return (
    <>
      <Layout
        title="CV Pau Guerrero"
        description="Currículum Vitae de Pau Guerrero"
        path="cv-pau-guerrero"
      >
        <>
          <h2 className="textHeading">Pau Guerrero</h2>
          <p className="textParagraph">Barcelona, 1971</p>
          <h3 className="textHeading">Exposicions</h3>
          <p className="textParagraph">
            <span>2022</span>
          </p>
          <p className="textParagraph">
            Cos - Paisatge (amb Eugeni Prieto). Vallgrassa Centre Experimental
            de les Arts (Begues, Barcelona)
          </p>
          <p className="textParagraph">
            Cos - Paisatge (amb Eugeni Prieto). Museu de la Mediterrània
            (Torroella de Montgrí, Girona)
          </p>
          <p className="textParagraph">
            Cos - Paisatge (amb Eugeni Prieto). Galeria fotogràfica Treseu (Vic,
            Barcelona)
          </p>
          <p className="textParagraph">
            <span>2021</span>
          </p>
          <p className="textParagraph">
            Antoni Campañà. L’endemà de la retirada: Portbou, 1939. Museu
            Memorial de l’Exili (Portbou, Girona).
          </p>
          <p className="textParagraph">
            20 Anys d’Exposicions (col·lectiva). Capella de Sant Antoni
            (Torroella de Montgrí, Girona).
          </p>
          <p className="textParagraph">
            <span>2020</span>
          </p>

          <p className="textParagraph">
            <a href="https://www.pauguerrero.cat/exposicions/muntanyes-caminant-treseu-vic/">
              Muntanyes Caminant. Galeria Treseu
            </a>{" "}
            (Vic, Barcelona)
          </p>

          <p className="textParagraph">
            <span>2019</span>
          </p>

          <p className="textParagraph">
            <a href="https://www.pauguerrero.cat/exposicions/the-other-art-fair-sydney/">
              The Print Swap (col·lectiva). The Other Art Fair
            </a>{" "}
            (Sydney, Austràlia)
          </p>

          <p className="textParagraph">
            <span>2018</span>
          </p>
          <p className="textParagraph">
            <a href="https://www.pauguerrero.cat/exposicions/0-figura-al-km7-espai-d-art/">
              0 Figura (col·lectiva).Km 7 Espai d’Art Jose Luis Pascual
            </a>
            (Saus-Camallera, Girona)
          </p>
          <p className="textParagraph">
            <a href="https://www.pauguerrero.cat/exposicions/muntanyes-caminant-al-claustre-del-hospital-de-torroella-de-montgri/">
              Muntanyes Caminant. Claustre de l'hospital
            </a>{" "}
            (Torroella de Montgrí, Girona)
          </p>
          <p className="textParagraph">
            <span>2017</span>
          </p>
          <p className="textParagraph">
            <a href="https://www.pauguerrero.cat/exposicions/muntanyes-caminant-a-pergam-llibres-barcelona/">
              Muntanyes Caminant. Pèrgam llibres
            </a>{" "}
            (Barcelona)
          </p>
          <p className="textParagraph">
            <a href="https://www.pauguerrero.cat/exposicions/monegros-a-km7-espai-d-art/">
              Monegros. Km 7 Espai d’Art
            </a>{" "}
            (Saus-Camallera, Girona)
          </p>
          <p className="textParagraph">
            <a href="https://www.pauguerrero.cat/exposicions/subhasta-d-art-per-a-chhimeki-nepal/">
              Grans artistes amb Nepal Chhimeki.
            </a>{" "}
            Bar Ocaña (Barcelona)
          </p>
          <p className="textParagraph">
            <a href="https://www.pauguerrero.cat/exposicions/paisatge-i-llegenda-del-comte-arnau-al-festival-mirades-de-torroella-de-montgri/">
              Paisatge i mite del comte Arnau. Festival Mirades
            </a>
            , Biennal de Fotografia (Torroella de Montgrí, Girona)
          </p>
          <p className="textParagraph">
            <span>2016</span>
          </p>
          <p className="textParagraph">
            <a href="https://www.pauguerrero.cat/exposicions/paisatge-evanescent-al-photogenic-festival-de-barcelona/">
              Paisatge Evanescent. Photogenic Festival
            </a>{" "}
            (Barcelona)
          </p>
          <p className="textParagraph">
            <a href="https://www.pauguerrero.cat/exposicions/paisatge-i-llegenda-del-comte-arnau-a-girona/">
              Paisatge i mite del comte Arnau. Biblioteca Carles Rahola
            </a>{" "}
            (Girona)
          </p>
          <p className="textParagraph">
            <span>2015</span>
          </p>
          <p className="textParagraph">
            <a href="https://www.pauguerrero.cat/exposicions/paisatge-i-llegenda-del-comte-arnau-a-sant-joan-de-les-abadesses/">
              Paisatge i mite del comte Arnau. Palau de l’Abadia
            </a>{" "}
            (Sant Joan de les Abadesses, Girona)
          </p>
          <p className="textParagraph">
            <a href="https://www.pauguerrero.cat/exposicions/taller-de-fotografia-de-paisatge-a-l-albera/">
              Paisatge i racons de l’Albera
            </a>{" "}
            (col·lectiva). Populart. (Capmany, Girona)
          </p>
          <p className="textParagraph">
            Flors i violes (col·lectiva) obra sobre paper. ArtistaEn
            (Palafrugell, Girona)
          </p>
          <p className="textParagraph">
            <span>2014</span>
          </p>
          <p className="textParagraph">
            <a href="https://www.pauguerrero.cat/exposicions/paisatge-i-llegenda-del-comte-arnau-al-observatori-del-paisatge/">
              Paisatge i mite del comte Arnau. Observatori del Paisatge de
              Catalunya
            </a>{" "}
            (Olot, Girona)
          </p>
          <p className="textParagraph">
            <span>2013</span>
          </p>
          <p className="textParagraph">
            <a href="https://www.pauguerrero.cat/exposicions/caigudes-d-aigua-km7/">
              Diàleg sobre la caiguda de l’aigua. Km 7 Espai d’Art Jose Luis
              Pascual
            </a>{" "}
            (Saus-Camallera, Girona)
          </p>
          <p className="textParagraph">
            <a href="https://www.pauguerrero.cat/exposicions/caigudes-d-aigua-tossa-de-mar/">
              Diàleg sobre la caiguda de l’aigua. Museu Municipal de Tossa de
              Mar
            </a>{" "}
            (Tossa de Mar, Girona)
          </p>

          <p className="textParagraph">
            Obres en col.leccions particulars i a la{" "}
            <a href="https://www.fundaciovilacasas.com/ca/obres/pau-guerrero">
              Col·lecció d'Art Contemporari Català
            </a>
            . Fundació Vila Casas.
          </p>
          <h3 className="textHeading">Xerrades</h3>
          <p className="textParagraph">
            Introducció a la fotografia (2020). Escola d’Arquitectura La Salle,
            Barcelona
          </p>
          <p className="textParagraph">
            Muntanyes Caminant (2017) Pèrgam llibres (Barcelona)
          </p>
          <p className="textParagraph">
            Paisatge i mite del comte Arnau (2017) Museu de la Mediterrània
            (Torroella de Montgrí, Girona)
          </p>
          <p className="textParagraph">
            Paisatge i mite del comte Arnau (2016) ACFAE (Figueres, Girona)
          </p>
          <p className="textParagraph">
            Paisatge i mite del comte Arnau (2016) Biblioteca Carles Rahola
            (Girona)
          </p>
          <p className="textParagraph">
            Paisatge i mite del comte Arnau (2015) Palau de l’Abadia (Sant Joan
            de les Abadesses, Girona)
          </p>
          <p className="textParagraph">
            Paisatge i mite del comte Arnau (2015) Palau de l’Abadia (Sant Joan
            de les Abadesses, Girona)
          </p>
          <p className="textParagraph">
            Paisatge i mite del comte Arnau (2014) Observatori del Paisatge de
            Catalunya (Olot, Girona)
          </p>
          <p className="textParagraph">
            Paisatge i mite del comte Arnau (2014) Les Tertulies d’en Joan
            (Barcelona)
          </p>
          <h3 className="textHeading">Llibres</h3>
          <p className="textParagraph">
            <a href="https://www.pauguerrero.cat/publicacions/monegros/">
              Monegros (2017) 20 x 30 cm · 112 pàgines · Impressió offset ·
              Edició de 500 copies.
            </a>
          </p>
          <p className="textParagraph">
            <a href="https://www.pauguerrero.cat/publicacions/el-comte-arnau-paisatge-i-llegenda/">
              Paisatge i mite del comte Arnau (2014) 48 pàgines 33 x 28 cm, ·
              Impressió inkjet · Edició de 100 còpies numerades i signades.
            </a>
          </p>
          <h3 className="textHeading">Tallers</h3>
          <p className="textParagraph">
            <a href="https://www.pauguerrero.cat/taller-iniciacio-fotografia-de-paisatge/">
              Iniciació a la fotografia de paisatge.
            </a>{" "}
            Taller d’un dia de durada, eminentment pràctic. Realitzat a la serra
            de Collserola, serra de l’Albera i cingles de Bertí.
          </p>
          <p className="textParagraph">
            <a href="https://www.pauguerrero.cat/taller-copies-fotografiques-de-qualitat/">
              Còpies fotogràfiques de qualitat.
            </a>{" "}
            Fotofilia, Vic, 2020
          </p>

          <div className="textLinks">
            <div className="textLink">
              <Link to="/pau-guerrero-text">Tornar</Link>
            </div>
          </div>
        </>
      </Layout>
    </>
  );
}
